import AjaxAddToCart from './lib/AjaxAddToCart';

export default AjaxAddToCart;
